<template>
  <div v-if="loading" class="flex justify-center items-center h-[240px]">
    <img class="w-64" src="/images/gifs/loading.gif" />
  </div>
  <div v-show="!loading">
    <p>{{
      `This new card will be used for your next invoice and your current card ${creditCardText} will be deleted`
    }}</p>
    <ChargifyIframes
      :chargify-client
      :editing="true"
      :show-disclaimer="false"
      @loaded="onLoaded"
      @form-ref-saved="(form) => (chargifyForm = form)"
    />
    <div class="flex justify-start gap-16">
      <BittsButton
        text="Cancel"
        variant="ghost"
        size="x-small"
        @click="emit('return-to-summary')"
      />
      <BittsButton
        text="Save"
        variant="outline"
        size="x-small"
        @click="handleGetToken"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

import { ref } from 'vue';

import useBilling from '@/composables/useBilling';
import { useFlashesStore } from '@/stores';

import ChargifyIframes from './ChargifyIframes.vue';

const { creditCardText, subscriptionType } = defineProps<{
  creditCardText: string;
  subscriptionType?: string;
}>();

const emit = defineEmits<(e: 'return-to-summary') => void>();

const loading = ref(true);

const flashesStore = useFlashesStore();
const { editPaymentMethod } = useBilling();

// @ts-expect-error we dont have access to the chargify client type
const chargifyClient = new Chargify();
const chargifyForm = ref<HTMLElement | null>(null);

function getToken() {
  return new Promise((resolve, reject) => {
    chargifyClient.token(
      chargifyForm.value,
      (token: Promise<void>) => {
        resolve(token);
      },
      (error: Promise<void>) => {
        reject(error);
      },
    );
  });
}
async function handleGetToken() {
  try {
    loading.value = true;
    const token = await getToken();
    const success = await editPaymentMethod({
      token,
      period: subscriptionType,
    });
    if (!success) {
      flashesStore.addErrorFlash('Failed to update payment information');
      return;
    }
    // editPaymentMethod already contains a success message
    emit('return-to-summary');
  } catch (err) {
    flashesStore.addErrorFlash('Failed to update payment information');
  } finally {
    loading.value = false;
  }
}

function onLoaded() {
  loading.value = false;
}
</script>

<style lang="pcss" scoped>
p {
  @apply text-neutral-text text-sm;
}
</style>
